export default __webpack_public_path__ + "static/16074-1a11fd6c6970fbb453b14bbc77328f2b.jpg";